import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SettingsService } from 'src/app/core/services';
import { PlayContentService } from 'src/app/core/services/play-content.service';
import { QueueListDurationPipe } from '../../pipes/queue-list-duration.pipe';
import { QueueListDatePipe } from '../../pipes/queue-list-date.pipe';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { RoundProgressComponent } from 'angular-svg-round-progressbar';

@Component({
  selector: 'app-audio-playlist',
  standalone: true,
  imports: [QueueListDurationPipe, QueueListDatePipe, RoundProgressComponent],
  templateUrl: './audio-playlist.component.html',
  styleUrl: './audio-playlist.component.scss'
})
export class AudioPlaylistComponent implements OnInit, OnChanges {
 @Input()currentPlayingContent;
 @Input()currentPlayingCollection;
 @Input()queData;
 @Input()currentPlayingPosition;
 @Input()isPlaying;
 @Input()totalPlaylistContent;
 @Input()personaApiFail;
 @Input()audioCollectionApiFail;
 @Input()actionButton;
 @Input()showLogin;
 @Input()currentPlayingContentGeoAvailability;
 @Input()currentProgressValue;
 @Input()currentPlayingEpisode;
 @Output()episodeSongInit = new EventEmitter();
 @Output()episodeSongPause = new EventEmitter();
 @Output()episodeSongPlay = new EventEmitter();
 @Output()audioSongInit = new EventEmitter();
 @Output()entitlementFunc = new EventEmitter();
 @Output()addToWishlistEmit = new EventEmitter();
 @Output()removeFromWishlistEmit =  new EventEmitter();
 @ViewChild('progressCircleContainer') progressCircleContainer!: ElementRef;

 currentPlayingType = '';
 selectedType='episode';
 currentPlayingEpisodeIndex;
 maxLengthToHide = 5;
 hideQueueLength = this.maxLengthToHide;
 hideQueueContent = this.maxLengthToHide;
 queueExpanded = false;
 seekbarBaseColor: string;
 seekbarProgressColor: string;
 episodeFirstPlayTrigger = false;

  constructor(public settingsService:SettingsService, public playContentService:PlayContentService, public configService:ConfigurationService){
    this.playContentService.selectedContentType.subscribe(data => this.currentPlayingType = data);
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {
    this.seekbarBaseColor = getComputedStyle(document.documentElement).getPropertyValue('--seekbar-base-color').trim();
    this.seekbarProgressColor = getComputedStyle(document.documentElement).getPropertyValue('--seekbar-progress-color').trim();
  }

  changeType(type){
    this.selectedType = type;
  }

  podcastPlayInit(position){
    if(this.currentPlayingEpisodeIndex != position){
      if(!this.episodeFirstPlayTrigger) this.episodeFirstPlayTrigger = true;
      this.currentPlayingEpisodeIndex = position;
      this.episodeSongInit.emit(position);
    }else this.episodeSongPlay.emit();
  }

  audioPlayInit(position){
    this.audioSongInit.emit(position);
  }

  podcastPlayPause(position){
      this.currentPlayingEpisodeIndex = position;
      this.episodeSongPause.emit();
  }

  addToWishlist(type, data){
    this.addToWishlistEmit.emit({type, data})
  }

  removeFromWishlist(type, data){
    this.removeFromWishlistEmit.emit({type, data})
  }

  expandViewall(){
    this.queueExpanded = true;
    this.hideQueueContent = this.totalPlaylistContent.length;
  }

  shrinkViewall(){
    this.queueExpanded = false;
    this.hideQueueContent = this.maxLengthToHide;
    this.hideQueueLength = this.maxLengthToHide;
  }

  entitlementFuncEmit(){
    this.entitlementFunc.emit()
  }
  
}